// extracted by mini-css-extract-plugin
var _1 = "kL2rs";
export { _1 as "base" }
